import { DashboardWidgetType } from 'features/dashboard/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import generateStaticStrategy from './staticStrategy'
import { WidgetSettingComposingStrategy } from './widgetSettingComposingStrategy'
import { pivotProductDecorator } from './decorator'

const generatePivotProductStrategy = (applicationSettings: any): WidgetSettingComposingStrategy => {
  const staticStrategy = generateStaticStrategy()
  const decoratedStrategy = pivotProductDecorator(applicationSettings, staticStrategy)

  return {
    ...decoratedStrategy,
    composeDrillDownWidgetSetting: (widgetSetting: DashboardWidgetType, insights: InsightData[]) =>
      decoratedStrategy.composeDrillDownWidgetSetting(widgetSetting, [], insights)
  }
}

export default generatePivotProductStrategy
